import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import ShareIcon from '@mui/icons-material/Share';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';

import { IconButton } from 'Components/IconButton';
import { ProductProps } from './Product.types';

export const Product = ({ product }: ProductProps) => {
	const navigate = useNavigate();

	return (
		<Grid item xs={6} sm={6} md={3}>
			<Card
				elevation={4}
				sx={{
					'&:hover': {
						boxShadow: 10
					}
				}}
			>
				<CardMedia
					component='iframe'
					src={product.url}
					title={product.name}
					height='360'
					width='100%'
					loading='lazy'
					frameBorder='0'
					sx={{
						backgroundColor: 'action.active',
						'&:hover': {
							cursor: 'pointer'
						}
					}}
				/>
				<CardContent>
					<Typography gutterBottom variant='body2' color='text.primary' fontWeight='medium'>
						{product.name}
					</Typography>
					<Typography variant='caption' color='text.secondary' fontWeight='bold'>
						{product.price} ICP
					</Typography>
				</CardContent>
				<Divider />
				<CardActions>
					<Box
						sx={{
							flexGrow: 1
						}}
					>
						<Button
							startIcon={<VisibilityIcon />}
							variant='contained'
							onClick={() => navigate(`/${product.id}`)}
						>
							View
						</Button>
					</Box>
					<IconButton icon={<FavoriteBorderIcon />} label='Add to favorites' color='error' />
					<IconButton icon={<ShareIcon />} label='Share' color='primary' />
				</CardActions>
			</Card>
		</Grid>
	);
};
